import { Component, OnInit } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { AjaxService, FormValidationService, UtilityService } from '../core';

@Component({
  selector: 'app-iylon-connect',
  templateUrl: './iylon-connect.component.html',
  styleUrls: ['./iylon-connect.component.less']
})
export class IylonConnectComponent implements OnInit {

  constructor(private _translateService: TranslateService,
    private _formValidationService: FormValidationService,
    private _ajaxService: AjaxService,
    private _confirmationService: ConfirmationService,
    private _router: ActivatedRoute,
    private _route: Router,
    private _utilityService: UtilityService) { }

    addIylonConnectForm = new FormGroup({});
    addIylonConnectmodel: any = {};
    addIylonConnectoptions: FormlyFormOptions = {};
    iylonConnectfields: FormlyFieldConfig[] = [];
    IylonConnectDetails: any;

    editDetails = false;

  ngOnInit(): void {
    this._router.params.subscribe(params => {
      console.log((window.atob(params.selectedDetails)))
      let selectedDetails=undefined;
       selectedDetails = (window.atob(params.selectedDetails));
    if(selectedDetails !==undefined){
      this.editDetails=true;
      this.getIylonConnectById(selectedDetails);
    }
    return selectedDetails
  });
  this.createIylonConnectForm();
  }


  createIylonConnectForm() {
    this.iylonConnectfields = [
      {
        key: 'Salutation',
        type: 'dropdown',
        wrappers: ['fieldWrapper'],        
        templateOptions: {
          
          optionsList: [
            { label: 'MR', value: 'MR' },
            { label: 'MRS', value: 'MRS' },
            { label: 'MS.', value: 'MS.' },
            { label: 'Dr', value: 'Dr' },
            { label: 'Other', value: 'Other' },
          ],
          valuePrimitve: true
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblSalutation'),
          'templateOptions.placeholder': this._translateService.stream('LblPlaceHolderSelect'),
          'templateOptions.disabled':this.editDetails?'true':'false'
        }
      },
      {
        key: 'FirstName',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {
          required: true
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblFirstName'),
          'templateOptions.disabled':this.editDetails?'true':'false'
        }
      },
      {
        key: 'LastName',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {
          required: true
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblLastName'),
          'templateOptions.disabled':this.editDetails?'true':'false'
        }
      },
      {
        key: 'Email',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {
          required: true
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblEmail'),
          'templateOptions.disabled':this.editDetails?'true':'false'
        }
      },
      {
        key: 'MobileNo',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {
          required: true
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblMobileNo'),
          'templateOptions.disabled':this.editDetails?'true':'false'
        }
      },

      {
        key: 'Age',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {
          required: true
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblAge'),
          'templateOptions.disabled':this.editDetails?'true':'false'
        }
      },

      {
        key: 'Sex',
        type: 'dropdown',
        defaultValue: null,
        wrappers: ['fieldWrapper'],
        templateOptions: {
          required: true,
          optionsList: [
            { label: 'Male', value: 'male' },
            { label: 'Female', value: 'female' },
          ],
          valuePrimitve: true,
          dataKey: 'value'
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblSex'),
          'templateOptions.placeholder': this._translateService.stream('LblPlaceHolderSelect'),
          'templateOptions.disabled':this.editDetails?'true':'false'
        }
      },
      {
        key: 'Diagnosis',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {
          required: false
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblDiagnosis'),
          'templateOptions.disabled':this.editDetails?'true':'false'
        }
      },
      {
        key: 'ApplyForDrug',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {
          required: false
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblApplyForDrug'),
          'templateOptions.disabled':this.editDetails?'true':'false'
        }
      },
      {
        key: 'Dossage',
        type: 'input',
        wrappers: ['fieldWrapper'],
        templateOptions: {
          required: false
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblDosage'),
          'templateOptions.disabled':this.editDetails?'true':'false'
        }
      },
      {
        key: 'Amount',
        type: 'input',
        defaultValue: '500',
        wrappers: ['fieldWrapper'],
        templateOptions: {
          required: true
        },
        expressionProperties: {
          'templateOptions.label': this._translateService.stream('LblAmount'),
          'templateOptions.disabled':'true'
        }
      },
    ];
  }



  submitConnectForm(){
    const value = { ...this.addIylonConnectmodel };
    console.log(value);
    
    this._ajaxService.post('/iylon-connect', value).subscribe((response) => {    
      if (response.success) {
        this._confirmationService.confirm({
          message: "Iylon Connect Details submitted successfully",
          rejectVisible: false,
          icon: 'pi pi-info-circle',
          acceptLabel: this._translateService.instant('LblOk'),
          accept: () => {
              this.addIylonConnectForm.reset(); 
          }
        });
      }      
    });
    
  }

  getIylonConnectById(Id:any) {
    this._ajaxService.get(`/iylon-connect/${Id}`).subscribe(result => {
      if (result.success) {
        this.addIylonConnectmodel = {
          ...result.data
        };
      }
    });
  }
    sendPaymentEmail() {
      let url =''
      const value = { ...this.addIylonConnectmodel }
      if(window.location.hostname.includes('localhost')){
        url = 'http://localhost:4200/#';
      }
      else if(window.location.hostname.includes('dev1.iylon.com')){
        url = 'https://dev1.iylon.com/#';
      }
      else if (window.location.hostname.includes('app.iylon.com')){
        url = 'https://app.iylon.com/#';//PROD
      }
      const route = url+'/iylonConnectPayment/' + btoa(JSON.stringify(value));
      value.sendPaymentLink=route

      this._ajaxService.post('/iylon-connect', value).subscribe((response) => {    
        if (response.success) {
          this._confirmationService.confirm({
            message: "Payment Link sent successfully",
            rejectVisible: false,
            icon: 'pi pi-info-circle',
            acceptLabel: this._translateService.instant('LblOk'),
          });
        }      
      });
    }
 
}
